export default __webpack_public_path__ + "static/media/contentful.35f2c12e.svg";